<template>
    <div class="baseOptionPage">
        <headerNotice routerName="基本设置"></headerNotice>
        <div class="baseOptionMain">
            <h2 class="baseOptionTitle">
                <i></i>
                <span>编辑支付参数</span>
            </h2>
            <!-- 表单 -->
            <el-form ref="baseOptionForm" label-width="180px">
                <el-form-item label="商城名称">
                    <el-input v-model="baseOptionForm.mallName"></el-input>
                </el-form-item>
                <el-form-item label="热门搜索关键字">
                    <el-input v-model="baseOptionForm.hotKeywords"></el-input>
                </el-form-item>
                <el-form-item label>
                    <span class="el-upload__tip">热门搜索关键字,请用半角逗号(,)分隔多个关键字</span>
                </el-form-item>
                <el-form-item label="商品默认图片">
                    <el-upload
                        :accept="accept"
                        :headers="headers"
                        class="avatar-uploader avatarBox"
                        :action="uploadAction"
                        :show-file-list="false"
                        :on-success="handleAddSuccess"
                        :before-upload="beforeUpload"
                    >
                        <img
                            v-if="baseOptionForm.itemDefaultImageUrl"
                            :src="baseUrl+baseOptionForm.itemDefaultImageUrl"
                            class="avatar"
                        >
                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                        <div slot="tip" class="el-upload__tip avatarTip">选择上传文件</div>
                        <div slot="tip" class="el-upload__tip uploadTip">只能上传图片，且不超过1M</div>
                    </el-upload>
                </el-form-item>
                <el-form-item label="客服电话" prop="serviceTelephone">
                    <el-input v-model="baseOptionForm.serviceTelephone"></el-input>
                </el-form-item>
                <el-form-item label="积分获取规则">
                    <el-input v-model="baseOptionForm.amount" type="number">
                        <span slot="prepend">每消费</span>
                        <span slot="append">元兑换1积分</span>
                    </el-input>
                </el-form-item>
                <!-- <el-form-item label="业务员积分充值规则">
                    <el-input v-model="baseOptionForm.salesmanRecharge" type="number">
                        <span slot="prepend">充值</span>
                        <span slot="append">元</span>
                    </el-input>
                </el-form-item>
                <el-form-item label>
                    <el-input v-model="baseOptionForm.salesmanGetIntegral" type="number">
                        <span slot="prepend">得到</span>
                        <span slot="append">积分</span>
                    </el-input>
                </el-form-item> -->
                <el-form-item label="最近购买商品">
                    <el-input v-model="baseOptionForm.recentPurchases" type="number">
                        <span slot="prepend">最近</span>
                        <span slot="append">个月商品</span>
                    </el-input>
                </el-form-item>
            </el-form>

            <el-form :model="baseOptionForm" label-width="180px">
                <h2 class="baseOptionTitle">
                    <i></i>
                    <span>运费设置</span>
                </h2>
                <el-form-item label="包邮起点">
                    <el-input type="number" v-model="baseOptionForm.freePostAmount">
                        <span slot="append">元</span>
                    </el-input>
                </el-form-item>
                <el-form-item label="邮费设置">
                    <el-input type="number" v-model="baseOptionForm.postage">
                        <span slot="append">元</span>
                    </el-input>
                </el-form-item>
            </el-form>

            <el-form :model="baseOptionForm" label-width="180px">
                <h2 class="baseOptionTitle">
                    <i></i>
                    <span>提现设置</span>
                </h2>
                <el-form-item label="单次提现最低金额">
                    <el-input type="number" v-model="baseOptionForm.minWithdrawDeposit">
                        <span slot="append">元</span>
                    </el-input>
                </el-form-item>
            </el-form>

            <el-form ref="baseOptionForm" :model="baseOptionForm" label-width="180px">
                <h2 class="baseOptionTitle">
                    <i></i>
                    <span>活动设置</span>
                </h2>
                <!-- <el-form-item label="提成比例">
                    <el-input type="number" v-model="baseOptionForm.commissionRate">
                        <span slot="append">%</span>
                    </el-input>
                </el-form-item>
                <el-form-item label="单次提现最小限额">
                    <el-input v-model="baseOptionForm.cashWithdrawalLimit" type="number">
                        <span slot="append">元</span>
                    </el-input>
                </el-form-item> -->
                <!-- <el-form-item label>
                    <span class="el-upload__tip">单次提现最小限额必须大于等于1元,限额在1-1000万以内</span>
                </el-form-item> -->
                <el-form-item label="活动积分">
                    <el-input type="number" v-model="baseOptionForm.activeIntegral">
                    </el-input>
                </el-form-item>
            </el-form>
            <el-form ref="baseOptionForm" :model="baseOptionForm">
                <!-- <h2 class="baseOptionTitle">
                    <i></i>
                    <span>用户协议</span>
                </h2>
                <el-form-item label>
                    <el-input
                        type="textarea"
                        v-model="baseOptionForm.agreement"
                        :autosize="{ minRows: 6, maxRows: 10}"
                    ></el-input>
                </el-form-item> -->
                <el-form-item class="textCenter">
                    <el-button type="primary" @click="sendBaseOption" :disabled="canSend">提交</el-button>
                </el-form-item>
            </el-form>
        </div>
    </div>
</template>

<script>
import headerNotice from './../../components/common/headerNotice.vue'
export default {
    data() {
        return {
            baseUrl: this.$store.state.apiUrl,
            uploadAction: this.$store.state.apiUrl + '/api/services/app/Image/UploadImage',//上传的服务器api地址
            headers: {
                'Authorization': localStorage.getItem('accessToken'),
            },
            accept: ".jpg,.jpeg,.png,.JPG,.JPEG,.PNG",
            canSend: false,//验证出错不能提交
            loading: true,
            baseOptionForm: {//表单数据
                mallName: '',
                hotKeywords: '',
                serviceTelephone: '',
                amount: 0,
                recentPurchases: 0,
                royalty: '',
                quota: '',
                integral: '',
                desc: '',
                commissionRate: 0,
                cashWithdrawalLimit: 0,
                customerType: 0,
                itemDefaultImageUrl: '',
                itemDefaultImage: '',
                freePostAmount: 0,
                minWithdrawDeposit:0,
                postage: 0
            },
            clientFileList: [],//上传列表数据
            //校验表单
        }
    },
    components: {
        headerNotice
    },
    mounted() {
        this.getBaseOption();
    },
    methods: {
        handleChange(file, fileList) {
            this.clientFileList = fileList.slice(-3);
        },
        //加载数据
        getBaseOption() {
            let self = this;
            this.loading = true;
            $http.GET({
                url: this.$store.state.apiUrl + "/api/services/app/AdminBasicConfig/GetDetail",
                params: {},
                success(res) {
                    if (res) {
                        self.baseOptionForm = res;
                    }
                    self.loading = false;
                },
                fail(res) {
                    self.loading = false;
                }
            })
        },
        //提交
        sendBaseOption() {
            let self = this;
            //中文逗号转换英文逗号
            this.baseOptionForm.hotKeywords = this.baseOptionForm.hotKeywords.replace(/，/ig, ',');
            // console.log(this.baseOptionForm);
            let reg = /(^[1-9]([0-9]+)?(\.[0-9]{1,2})?$)|(^(0){1}$)|(^[0-9]\.[0-9]([0-9])?$)/
            let ismoney = reg.test(this.baseOptionForm.commissionRate)
            if (!ismoney) {
                this.$message.error('提成比例最多保留两位小数')
                return
            }
            if (!reg.test(this.baseOptionForm.freePostAmount)) {
                this.$message.error('请填写正确的包邮起点')
                return
            }
            if (!reg.test(this.baseOptionForm.postage)) {
                this.$message.error('请填写正确的邮费设置')
                return
            }
            $http.POST({
                url: this.$store.state.apiUrl + "/api/services/app/AdminBasicConfig/Setup",
                data: this.baseOptionForm,
                success(res) {
                    // console.log(res);
                    self.$message({
                        message: res.data,
                        type: 'success'
                    });
                },
                fail(res) {
                    // console.log(res);
                    self.$message({
                        message: res.message,
                        type: 'warning'
                    });
                }
            })
        },
        //上传图片之前
        beforeUpload(file) {
            const isLt2M = file.size / 1024 / 1024 < 1;
            if (file.type != 'image/jpeg' && file.type != 'image/png' && file.type != 'image/gif') {
                this.$message.error('上传的图片只支持JPG/PNG/GIF 的格式!');
                return false;
            }
            if (!isLt2M) {
                this.$message.error('上传图片大小不能超过 1MB!');
            }
            return isLt2M;
        },

        //图片上传成功
        handleAddSuccess(response, file, fileList) {
            // console.log(response);
            this.baseOptionForm.itemDefaultImage = response.result.fileName;
            this.baseOptionForm.itemDefaultImageUrl = response.result.url
            // console.log(this.baseUrl + this.baseOptionForm.itemDefaultImageUrl);
            // this.itemDefaultImageUrl = URL.createObjectURL(file.raw);
        },
    }
}
</script>

<style lang='scss' scoped>
.baseOptionPage {
    .baseOptionMain {
        width: 50%;
        margin: 20px auto;
        padding: 0 20px 20px 20px;
        background: white;
        border: 1px solid #c5c5c5;
        .baseOptionTitle {
            width: 100%;
            height: 40px;
            line-height: 40px;
            margin-bottom: 10px;
            border-bottom: 1px solid #c5c5c5;
            h2 {
                padding-left: 20px;
            }
        }
        .textCenter {
            text-align: center;
        }
    }
}
</style>
<style lang="scss">
.baseOptionMain {
    .el-input {
        width: 50%;
    }
    .el-upload-list__item {
        width: 50%；;
    }
    .avatar-uploader .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }
    .avatar-uploader .el-upload:hover {
        border-color: #409eff;
    }
    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 178px;
        height: 178px;
        line-height: 178px;
        text-align: center;
    }
    .avatar {
        width: 178px;
        height: 178px;
        display: block;
    }
}
</style>